import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Table from './Table.jsx'
//import _ from 'lodash'

const headers = [
  'name',
  'managers',
  'oncall',
]

class TeamsComponent extends Component{
  componentDidMount() {
    this.props.fetchData()
  }

  render() {
    return <Table teams={this.props.teams} headers={headers}></Table>
  }
}

TeamsComponent.propTypes = {
  fetchData: PropTypes.func.isRequired,
  teams: PropTypes.object.isRequired,
}

export default TeamsComponent
